import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    progressHint: `Just a few seconds...`,
    title: `We retrieve your identity document analysis report...`,
  },
  fr: {
    progressHint: 'Quelques secondes restantes...',
    title:
      'Nous récupérons le rapport d’analyse de votre document d’identité...',
  },
} as const);

export default locales;
